// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}body,html{background:#ccc;height:100%;width:100%}button{font-size:24pt;border-radius:100px;background:#1792cb;padding:12px 24px;color:#fff;border:4px solid #fff;cursor:pointer;margin:32px auto;display:block}button:hover{opacity:.7}", ""]);
// Exports
module.exports = exports;
